<h2 mat-dialog-title>{{data.header}}</h2>
<div class="content" mat-dialog-content >
  <h3>{{data.message}}</h3>
</div>
<div mat-dialog-actions fxLayout="column" fxLayoutAlign="center center">
  <button class="primary" mat-raised-button color="primary" (click)="onOkClick()" >OK</button>
</div>
